import React from 'react';
import Homepage from './pages/home/HomePage';

function App() {
  return <Homepage />;
}

export default App;
